import React, {useState, useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Modal from 'react-bootstrap/esm/Modal';
import TrafficTimeService from '@app/services/trafficTime.service';
import {Button} from '@app/components/index';

const SEGMENTOS = ['SVV','SGE','TETRA'];
const GRAVEDADES = ['CRITICA','GRAVE','LEVE','BAJA'];

const schema = Yup.object({
    segmento_tt: Yup.string().oneOf(SEGMENTOS, 'Segmento invalido').required('El segmento es obligatorio'),
    gravedad_tt: Yup.string().oneOf(GRAVEDADES, 'Gravedad invalida').required('La gravedad es obligatoria'),
    nivelVerdeHoursCapital_tt: Yup.number()
        .typeError('El nivel verde (Capital) debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel verde (Capital) en horas es obligatorio'),
    nivelAmarilloHoursCapital_tt: Yup.number()
        .typeError('El nivel amarillo (Capital) debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel amarillo (Capital) en horas es obligatorio'),
    nivelNaranjaHoursCapital_tt: Yup.number()
        .typeError('El nivel naranja (Capital) debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel naranja (Capital) en horas es obligatorio'),
    nivelRojoHoursCapital_tt: Yup.number()
        .typeError('El nivel rojo (Capital) debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel rojo (Capital) en horas es obligatorio'),
    nivelVerdeHours_tt: Yup.number()
        .typeError('El nivel verde debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel verde en horas es obligatorio'),
    nivelAmarilloHours_tt: Yup.number()
        .typeError('El nivel amarillo debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel amarillo en horas es obligatorio'),
    nivelNaranjaHours_tt: Yup.number()
        .typeError('El nivel naranja debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel naranja en horas es obligatorio'),
    nivelRojoHours_tt: Yup.number()
        .typeError('El nivel rojo debe ser un numero')
        .integer('Debe ser un entero')
        .min(0, 'Debe ser >= 0')
        .required('El nivel rojo en horas es obligatorio')
});

function ModalTrafficTime({show, hideModal, item, onGuardar}) {
    const [isLoading, setIsLoading] = useState(false);

    const {register, handleSubmit, errors} = useForm({
        resolver: yupResolver(schema),
        defaultValues: item
    });

    const onSubmit = (values) => {
        const data = {
            ...values,
            nivelVerdeHoursCapital_tt: Number(values.nivelVerdeHoursCapital_tt),
            nivelAmarilloHoursCapital_tt: Number(values.nivelAmarilloHoursCapital_tt),
            nivelNaranjaHoursCapital_tt: Number(values.nivelNaranjaHoursCapital_tt),
            nivelRojoHoursCapital_tt: Number(values.nivelRojoHoursCapital_tt),
            nivelVerdeHours_tt: Number(values.nivelVerdeHours_tt),
            nivelAmarilloHours_tt: Number(values.nivelAmarilloHours_tt),
            nivelNaranjaHours_tt: Number(values.nivelNaranjaHours_tt),
            nivelRojoHours_tt: Number(values.nivelRojoHours_tt)
        };
        setIsLoading(true);
        if (item && item.id_tt > 0) {
            TrafficTimeService.update({ ...data, id_tt: item.id_tt })
                .then(() => {
                    onGuardar();
                    hideModal();
                })
                .finally(() => setIsLoading(false));
        } else {
            TrafficTimeService.register(data)
                .then(() => {
                    onGuardar();
                    hideModal();
                })
                .finally(() => setIsLoading(false));
        }
    };

    const handleClose = () => hideModal();

    useEffect(() => {
        register('segmento_tt');
        register('gravedad_tt');
        register('nivelVerdeHoursCapital_tt');
        register('nivelAmarilloHoursCapital_tt');
        register('nivelNaranjaHoursCapital_tt');
        register('nivelRojoHoursCapital_tt');
        register('nivelVerdeHours_tt');
        register('nivelAmarilloHours_tt');
        register('nivelNaranjaHours_tt');
        register('nivelRojoHours_tt');
    }, [register]);

    const esEdicion = item && item.id_tt > 0;

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {esEdicion ? 'Editar Traffic Time' : 'Registrar Traffic Time'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="segmento_tt">
                                        {'Segmento '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className={`form-control ${errors.segmento_tt ? 'is-invalid' : ''}`}
                                        id="segmento_tt"
                                        name="segmento_tt"
                                        ref={register}
                                    >
                                        <option value="">Seleccione...</option>
                                        {SEGMENTOS.map((s) => (
                                            <option key={s} value={s}>{s}</option>
                                        ))}
                                    </select>
                                    {errors.segmento_tt && (
                                        <div className="invalid-feedback">
                                            {errors.segmento_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="gravedad_tt">
                                        {'Gravedad '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        className={`form-control ${errors.gravedad_tt ? 'is-invalid' : ''}`}
                                        id="gravedad_tt"
                                        name="gravedad_tt"
                                        ref={register}
                                    >
                                        <option value="">Seleccione...</option>
                                        {GRAVEDADES.map((g) => (
                                            <option key={g} value={g}>{g}</option>
                                        ))}
                                    </select>
                                    {errors.gravedad_tt && (
                                        <div className="invalid-feedback">
                                            {errors.gravedad_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="col-12 mt-2">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fas fa-city text-primary mr-2" />
                                    <h6 className="mb-0 text-primary">Capital</h6>
                                </div>
                                <hr className="mt-1 mb-2" />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelVerdeHoursCapital_tt">
                                        <i className="fas fa-circle" style={{color:'#28a745'}} />
                                        {' Verde Capital (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelVerdeHoursCapital_tt ? 'is-invalid' : ''}`}
                                        id="nivelVerdeHoursCapital_tt"
                                        name="nivelVerdeHoursCapital_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelVerdeHoursCapital_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelVerdeHoursCapital_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelAmarilloHoursCapital_tt">
                                        <i className="fas fa-circle" style={{color:'#ffc107'}} />
                                        {' Amarillo Capital (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelAmarilloHoursCapital_tt ? 'is-invalid' : ''}`}
                                        id="nivelAmarilloHoursCapital_tt"
                                        name="nivelAmarilloHoursCapital_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelAmarilloHoursCapital_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelAmarilloHoursCapital_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelNaranjaHoursCapital_tt">
                                        <i className="fas fa-circle" style={{color:'#fd7e14'}} />
                                        {' Naranja Capital (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelNaranjaHoursCapital_tt ? 'is-invalid' : ''}`}
                                        id="nivelNaranjaHoursCapital_tt"
                                        name="nivelNaranjaHoursCapital_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelNaranjaHoursCapital_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelNaranjaHoursCapital_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelRojoHoursCapital_tt">
                                        <i className="fas fa-circle" style={{color:'#dc3545'}} />
                                        {' Rojo Capital (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelRojoHoursCapital_tt ? 'is-invalid' : ''}`}
                                        id="nivelRojoHoursCapital_tt"
                                        name="nivelRojoHoursCapital_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelRojoHoursCapital_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelRojoHoursCapital_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="col-12 mt-2">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fas fa-globe-americas text-success mr-2" />
                                    <h6 className="mb-0 text-success">Interior</h6>
                                </div>
                                <hr className="mt-1 mb-2" />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelVerdeHours_tt">
                                        <i className="fas fa-circle" style={{color:'#28a745'}} />
                                        {' Verde Interior (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelVerdeHours_tt ? 'is-invalid' : ''}`}
                                        id="nivelVerdeHours_tt"
                                        name="nivelVerdeHours_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelVerdeHours_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelVerdeHours_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelAmarilloHours_tt">
                                        <i className="fas fa-circle" style={{color:'#ffc107'}} />
                                        {' Amarillo Interior (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelAmarilloHours_tt ? 'is-invalid' : ''}`}
                                        id="nivelAmarilloHours_tt"
                                        name="nivelAmarilloHours_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelAmarilloHours_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelAmarilloHours_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelNaranjaHours_tt">
                                        <i className="fas fa-circle" style={{color:'#fd7e14'}} />
                                        {' Naranja Interior (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelNaranjaHours_tt ? 'is-invalid' : ''}`}
                                        id="nivelNaranjaHours_tt"
                                        name="nivelNaranjaHours_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelNaranjaHours_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelNaranjaHours_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-3">
                                <div className="form-group">
                                    <label className="label-control" htmlFor="nivelRojoHours_tt">
                                        <i className="fas fa-circle" style={{color:'#dc3545'}} />
                                        {' Rojo Interior (hs) '}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        className={`form-control ${errors.nivelRojoHours_tt ? 'is-invalid' : ''}`}
                                        id="nivelRojoHours_tt"
                                        name="nivelRojoHours_tt"
                                        type="number"
                                        min="0"
                                        step="1"
                                        ref={register}
                                    />
                                    {errors.nivelRojoHours_tt && (
                                        <div className="invalid-feedback">
                                            {errors.nivelRojoHours_tt?.message}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {!esEdicion && (
                                <div className="col-12">
                                    <small className="text-muted">
                                        Si ya existe una configuracion activa con el mismo segmento y gravedad,
                                        sera marcada como historica y este nuevo registro quedara activo.
                                    </small>
                                </div>
                            )}
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button theme="default" onClick={handleClose}>
                    CANCELAR
                </Button>
                <Button
                    theme="primary"
                    onClick={handleSubmit(onSubmit)}
                    isLoading={isLoading}
                >
                    GUARDAR
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

ModalTrafficTime.defaultProps = {
    show: false,
    item: {
        id_tt: 0,
        segmento_tt: '',
        gravedad_tt: '',
        nivelVerdeHoursCapital_tt: '',
        nivelAmarilloHoursCapital_tt: '',
        nivelNaranjaHoursCapital_tt: '',
        nivelRojoHoursCapital_tt: '',
        nivelVerdeHours_tt: '',
        nivelAmarilloHours_tt: '',
        nivelNaranjaHours_tt: '',
        nivelRojoHours_tt: ''
    }
};

export default ModalTrafficTime;
